import React from 'react';
import { Navbar } from 'components';
import './layoutWithNavbar.scss';

const layoutWithNavbar = Wrapped => props => (
  <div className="app-wrapper">

    <Navbar {...props} />

    <main className="app-wrapper__content">
      <Wrapped {...props} />
    </main>
  </div>
);

export default layoutWithNavbar;
